import { useNavigate } from 'react-router-dom';

import SidePanel from '@semcore/ui/side-panel';

import { publisherRoutes } from '@/shared/lib';

import { SliderContentForm } from './SliderContentForm';

// TODO: SidePaner (form) should be moved into separate component
import s from '../../features/content-form/ui/SideForm.module.css';

export function SliderContentPage() {
  const navigate = useNavigate();

  return (
    <SidePanel
      visible
      closable={false}
      wMax="100%"
      w="100%"
      px="0"
      py="0"
      className={`rounded-0 min-h-dvh ${s.panel}`}
      duration={0}
    >
      <SliderContentForm onClose={() => navigate(publisherRoutes.content)} />
    </SidePanel>
  );
}
